import { AlertCircle, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface DevBannerProps {
  simulatedIsMatriz: boolean;
  onToggleSimulatedMatriz: (value: boolean) => void;
  onResetState: () => void;
}

/**
 * Banner DEV para /clientes-tabs
 * Mostra informações de teste e permite simular estado de Matriz
 */
export default function DevBanner({
  simulatedIsMatriz,
  onToggleSimulatedMatriz,
  onResetState,
}: DevBannerProps) {
  return (
    <Alert className="mb-4 bg-yellow-50 border-yellow-200">
      <AlertCircle className="h-4 w-4 text-yellow-600" />
      <AlertDescription className="text-yellow-800">
        <div className="flex items-center justify-between gap-4">
          <div className="text-sm">
            <strong>🧪 Ambiente de Teste UI</strong> — Você está em{" "}
            <code className="bg-yellow-100 px-2 py-1 rounded text-xs font-mono">
              /clientes-tabs
            </code>
          </div>
          <div className="flex items-center gap-3">
            <label className="flex items-center gap-2 cursor-pointer text-sm">
              <input
                type="checkbox"
                checked={simulatedIsMatriz}
                onChange={(e) => onToggleSimulatedMatriz(e.target.checked)}
                className="w-4 h-4"
              />
              <span>Simular Matriz</span>
            </label>
            <Button
              variant="outline"
              size="sm"
              onClick={onResetState}
              className="gap-2"
            >
              <RotateCcw className="w-3 h-3" />
              Recarregar Estado
            </Button>
          </div>
        </div>
      </AlertDescription>
    </Alert>
  );
}
